import { render } from "./MainSlider.vue?vue&type=template&id=3a42975b&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"

import "./MainSlider.vue?vue&type=style&index=0&id=3a42975b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a42975b"]])

export default __exports__